import { formatDistance, isValid } from 'date-fns'

export const getFormattedTimeLeft = expiry => {
  if (!isValid(expiry)) {
    return 'invalid date'
  }
  return formatDistance(new Date(expiry), new Date())
}
